<template>
  <transition name="fade">
    <div v-if="visible" class="cg_toast regular">
      <div class="toast-content">
        <div v-html="message"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: '',
    }
  },
  methods: {
    showToast(msg, duration = 2500) {
      this.message = msg
      this.visible = true
      setTimeout(() => {
        this.visible = false
      }, duration)
    },
  },
}
</script>

<style scoped>
.cg_toast {
  position: fixed;
  top: 30%;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999999999;
  height: auto;
  display: flex;
  justify-content: center;
  overflow: visible;
  padding: 20px 0;
}
.cg_toast .toast-content {
  display: flex;
  background: #ffffff;
  box-shadow:
    0px 12px 24px 0px rgba(0, 0, 0, 0.1),
    0px 6px 46px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  gap: 10px;
  min-width: 120px;
  max-width: 240px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  color: #202226;
  font-weight: 400;
}
.cg_toast .toast-content span {
  font-size: 15px;
  line-height: 1.4;
  color: #343a3f;
}
.cg_toast img {
  height: 22px;
  display: block;
  width: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
